import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-loading-header',
  templateUrl: './loading-header.component.html',
  styleUrls: ['./loading-header.component.scss'],
})
export class LoadingHeaderComponent {
  @Input() public loading: boolean = false;
}
